import { jsx as _jsx } from "react/jsx-runtime";
import { Radio } from '@mui/material';
const debug = process.env.REACT_APP_DEBUG && false;
export const radioSelector = ({ gridCellParams, valueSetter }) => {
    return (_jsx(Radio, { checked: gridCellParams.value,
        size: 'small',
        sx: { padding: 0 },
        onClick: () => {
            valueSetter(!gridCellParams.value, gridCellParams.id);
        } }));
};
export function SelectAll({ items, selectedObjects, setSelectedObjects }) {
    const handleToggle = () => {
        items.length === selectedObjects.length ? setSelectedObjects([]) : setSelectedObjects(items);
    };
    return (_jsx(Radio, { size: 'small',
        sx: { padding: 0 },
        checked: items.length === selectedObjects.length, // approximately. Dont want to iterate to compare
        onClick: handleToggle }));
}
